module.exports = __webpack_public_path__ + "6908b7a96e28d45092b28b4e3175f85f.jpg";